const React = require('react')
const QueryString = require('query-string')
import api from '../../utils/api'
import gtagHelper from '../../utils/gtagHelper'

import _ from 'lodash'
import {
  Col,
  DropdownButton,
  Jumbotron,
  MenuItem,
  Row,
} from 'react-bootstrap'
import { isMobile, isMobileOnly } from 'react-device-detect'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'

import { GenericError, GenericErrorModal } from '../shared/GenericError'
import CollectionBanners from './CollectionBanners'
import Pagination from '../shared/Pagination'
import SearchProgress from '../shared/SearchProgress'
import Site from './Site'
import SiteMobile from './SiteMobile'
import SiteTutorial from './SiteTutorial'
import BoostSiteFilterWeb from './BoostSiteFilterWeb'
import BoostSiteFilterMobile from './BoostSiteFilterMobile'
import SiteTutorialMobile from './SiteTutorialMobile'

export default class BoostSites extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      hasError: false,
      pagination: {
        offset: 0,
        limit: 12
      },
      orderBy: 'Curriculum Standard',
      orderChoices: ['Curriculum Standard', 'Downloads', 'Most Recent'],
      query: '',
      results: null,
      result_count: null,
      curriculum: {
        selectedContentStandard: null,
        selectedCurriculumVersion: null,
        selectedCurriculumView: null,
        selectedLearningSkill: null,
        selectedSubject: null,
        selectedSyllabus: null,
        selectedUnit: null,
        selectedYear: null,
        currentLearningSkills: null,
        currentContentStandards: null,
        currentSyllabuses: null,
        currentUnits: null,
        curriculumVersion: null,
        curriculumView: null,
        subjects: null,
        syllabuses: null,
        units: null,
        years: null,
        views: [{ id: 'curriculum', name: "Curriculum View" }, { id: 'syllabus', name: "Syllabus View" }],
        showCurriculumVersionSelection: 0,
        showCurriculumViewSelection: 0
      },
      showFrogPlayPopover: false,
      showYearPopover: false,
      showGenericErrorModal: false,
      showTutorialModal: false,
      selectedCollection: null,
      source: null, // check where the source is coming from i.e. Lesson Planner or just Boost App
      availableKeyword: null, // currently used for frogmaker integration
      selectedKeywordId: null, // currently used for frogmaker integration
      selectedSite: null,
      //stores information if a subject is filtered but unavailable
      unavailableSubject: null,
      isMobileFilter: false,
      isFilterShow: false,
      currScrollY: 0,
      isMore: false,
      downloadList: []
    }
    this.deriveCurriculumStateFromSelection = this.deriveCurriculumStateFromSelection.bind(this)
    this.doSiteAdd = this.doSiteAdd.bind(this)
    this.doSearch = this.doSearch.bind(this)
    this.handleAddingSite = this.handleAddingSite.bind(this)
    this.handleCollectionClear = this.handleCollectionClear.bind(this)
    this.handleFilterChange = this.handleFilterChange.bind(this)
    this.handleFilterClear = this.handleFilterClear.bind(this)
    this.handleKeywordClear = this.handleKeywordClear.bind(this)
    this.handleOrderChange = this.handleOrderChange.bind(this)
    this.handleQueryChange = this.handleQueryChange.bind(this)
    this.handleSearchButton = this.handleSearchButton.bind(this)
    this.handleSearchChange = this.handleSearchChange.bind(this)
    this.handleSearchClear = this.handleSearchClear.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)

    this.getCurrentPage = this.getCurrentPage.bind(this)
    this.nextPage = this.nextPage.bind(this)
    this.prevPage = this.prevPage.bind(this)
    this.gotoPage = this.gotoPage.bind(this)

    //tell the parent (VLE) that we have finished loading
    window.parent.postMessage({ type: 'boost.loaded' }, '*')
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.location != this.props.location) {
      const queryParams = QueryString.parse(nextProps.location.search)
      if (window.doSearch)
        clearTimeout(window.doSearch)

      window.doSearch = window.setTimeout(() => {
        this.doSearch('siteSearch', queryParams)
      }, 300)
    }
  }

  async componentDidMount() {
    window.addEventListener('scroll', this.scrollHandler);

    const queryParams = QueryString.parse(this.props.location.search, { arrayFormat: 'bracket' });
    try {
      const years = await api.getAllYears()

      this.setState({
        query: queryParams.q || '',
        selectedCollection: queryParams.collection
          ? window.__COLLECTIONS.filter(c => c.id == queryParams.collection)[0]
          : null,

        source: queryParams.source || null,

        showTutorialModal: queryParams.source == 'lessonplanner' ? false : true,

        selectedKeywordId: queryParams.keyword || null,

        curriculum: {
          ...this.state.curriculum,
          years: years
        },

        orderBy: _.includes(this.state.orderChoices, queryParams.orderBy)
          ? queryParams.orderBy
          : 'Curriculum Standard',

        pagination: {
          ...this.state.pagination,
          offset: parseInt(queryParams.offset) || 0,
        }
      }, async () => {
        var cState = this.state.curriculum
        const {
          name: selectedYearName,
          fromWindowUser: showYearPopover
        } = this.getSelectedYearName(queryParams, window.__USER)
        if (selectedYearName) {
          const year = _.find(this.state.curriculum.years, { name: selectedYearName })
          cState = await this.deriveCurriculumStateFromSelection(cState, year, 'selectedYear')
        }
        if (queryParams.subject) {
          const subject = _.find(this.state.curriculum.subjects, { name: queryParams.subject })
          cState = await this.deriveCurriculumStateFromSelection(cState, subject, 'selectedSubject')
        }
        if (queryParams.curriculumVersion) {
          const curriculumVersion = _.find(this.state.curriculum.curriculumVersions, { name: queryParams.curriculumVersion })
          cState = await this.deriveCurriculumStateFromSelection(cState, curriculumVersion, 'selectedCurriculumVersion')
        }
        if (queryParams.curriculumView) {
          const curriculumView = _.find(this.state.curriculum.views, { name: queryParams.curriculumView })
          cState = await this.deriveCurriculumStateFromSelection(cState, curriculumView, 'selectedCurriculumView')
        }
        if (queryParams.learningSkill) {
          const learningSkill = _.find(this.state.curriculum.currentLearningSkills, { uuid: queryParams.learningSkill })
          cState = await this.deriveCurriculumStateFromSelection(cState, learningSkill, 'selectedLearningSkill')
        }
        if (queryParams.contentStandard) {
          const contentStandard = _.find(this.state.curriculum.currentContentStandards, { uuid: queryParams.contentStandard })
          cState = await this.deriveCurriculumStateFromSelection(cState, contentStandard, 'selectedContentStandard')
        }
        if (queryParams.syllabus) {
          const syllabus = _.find(this.state.curriculum.currentSyllabuses, { uuid: queryParams.syllabus })
          cState = await this.deriveCurriculumStateFromSelection(cState, syllabus, 'selectedSyllabus')
        }
        if (queryParams.unit) {
          const unit = _.find(this.state.curriculum.currentUnits, { uuid: queryParams.unit })
          cState = await this.deriveCurriculumStateFromSelection(cState, unit, 'selectedUnit')
        }

        //check if utm tag from FrogPlay is there.
        const showFrogPlayPopover = queryParams.utm_source == 'FrogPlay' && (queryParams.year || queryParams.subject)
          ? true
          : false

        //automatically hide the popovers
        window.setTimeout(() => {
          this.setState({
            showFrogPlayPopover: false,
            showYearPopover: false,
          })
        }, 10000);

        this.setState({
          curriculum: cState,
          showFrogPlayPopover,
          //set to false if frogplay popover is true
          showYearPopover: !showFrogPlayPopover && showYearPopover
        }, this.handleSubmit(null, this.state.pagination.offset))
      })

      if (!isMobile) { // this feature is hidden from mobile view
        const availableKeyword = await api.getTemplateKeyword()
        this.setState({
          availableKeyword: Object.keys(availableKeyword).length === 0 ? null : availableKeyword
        })
      }
    } catch (e) {
      this.setState({
        showGenericErrorModal: true
      })
    }

  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.scrollHandler)
  }

  scrollHandler = () => {
    var self = this
    // for sticky header
    var scrollTop = window.scrollY
    var isSticky = false
    isSticky = scrollTop <= this.state.currScrollY && scrollTop > 16
    this.setState({
      ...this.state,
      isFilterShow: isSticky,
      currScrollY: scrollTop,
      isMobileFilter: scrollTop > 16 ? false : this.state.isMobileFilter
    }, () => {
      // for load more records
      if (Math.ceil(window.innerHeight + document.documentElement.scrollTop) !== document.documentElement.offsetHeight) {
        return;
      }
      // load more records
      if (isMobile) {
        self.setState({
          ...self.state,
          isMore: true
        }, () => {
          self.loadMoreRecords()
        })
      }
    })
  }

  /**
   *
   * @param {Object} cState Initial curriculum object
   * @param {Item} item
   * @param {string} itemPropKey The property being modified in the curriculum state
   * @return {Object} cState A new object to use
   */
  async deriveCurriculumStateFromSelection(cState = {}, item, itemPropKey) {
    async function getSubjects(yearId) {
      const result = await api.getSubjects(yearId)
      return result
    }
    async function getCurriculumVersions(yearId, subjectId) {
      const result = await api.getCurriculumVersions(yearId, subjectId)
      return result
    }
    async function getLearningSkills(yearId, subjectId, curriculumVersionId) {
      const result = await api.getLearningSkills(yearId, subjectId, curriculumVersionId)
      return result.filter(item => !item.name.includes('Performance Level'));
    }
    async function getSyllabuses(yearId, subjectId, curriculumVersionId) {
      const result = await api.getSyllabuses(yearId, subjectId, curriculumVersionId)
      return result
    }
    cState[itemPropKey] = item
    switch (itemPropKey) {
      case 'selectedYear':
        //if year selected
        cState.subjects = item
          ? await getSubjects(item.id)
          : null
        cState.currentLearningSkills = null
        cState.currentContentStandards = null
        cState.currentSyllabuses = null
        cState.currentUnits = null
        cState.selectedSubject = null
        cState.selectedCurriculumVersion = null
        cState.selectedCurriculumView = null
        cState.selectedLearningSkill = null
        cState.selectedContentStandard = null
        cState.selectedSyllabus = null
        cState.selectedUnit = null
        cState.showCurriculumVersionSelection = 0
        cState.showCurriculumViewSelection = 0
        break
      case 'selectedSubject':
        //if year, subject selected
        cState.curriculumVersions = item && this.state.curriculum.selectedYear
          ? await getCurriculumVersions(this.state.curriculum.selectedYear.id, item.id)
          : null
        cState.currentLearningSkills = null
        cState.currentContentStandards = null
        cState.currentSyllabuses = null
        cState.currentUnits = null
        cState.selectedCurriculumVersion = null
        cState.selectedCurriculumView = null
        cState.selectedLearningSkill = null
        cState.selectedContentStandard = null
        cState.selectedSyllabus = null
        cState.selectedUnit = null

        cState.showCurriculumVersionSelection = this.state.curriculum.selectedSubject
          ? this.state.curriculum.selectedSubject.filter_show_curriculum_version
          : 0
        cState.showCurriculumViewSelection = this.state.curriculum.selectedSubject
          ? this.state.curriculum.selectedSubject.filter_show_curriculum_view
          : 0

        if (cState.curriculumVersions && cState.curriculumVersions.length > 1) {
          cState.showCurriculumVersionSelection = 1
          this.deriveCurriculumStateFromSelection(cState, cState.curriculumVersions[cState.curriculumVersions.length - 1], 'selectedCurriculumVersion')
        }
        else if (cState.showCurriculumVersionSelection != 1 && cState.curriculumVersions) {
          this.deriveCurriculumStateFromSelection(cState, cState.curriculumVersions[0], 'selectedCurriculumVersion')
        }

        break
      case 'selectedCurriculumVersion':
        //if year, subject, curriculum version selected
        cState.currentLearningSkills = null
        cState.currentContentStandards = null
        cState.currentSyllabuses = null
        cState.currentUnits = null
        cState.selectedLearningSkill = null
        cState.selectedContentStandard = null
        cState.selectedSyllabus = null
        cState.selectedUnit = null
        cState.selectedCurriculumVersion = item
        cState.selectedCurriculumView = _.find(this.state.curriculum.views, { id: this.state.curriculum.selectedSubject.filter_default_curriculum_view })

        this.deriveCurriculumStateFromSelection(cState, cState.selectedCurriculumView, 'selectedCurriculumView')
        break
      case 'selectedCurriculumView':
        //if year, subject, curriculum version, curriculum view selected
        cState.selectedCurriculumView = item
        cState.selectedLearningSkill = null
        cState.selectedContentStandard = null
        cState.selectedSyllabus = null
        cState.selectedUnit = null

        if (item && item.id == 'syllabus') {
          cState.currentSyllabuses = item && this.state.curriculum.selectedYear && this.state.curriculum.selectedSubject && this.state.curriculum.selectedCurriculumVersion
            ? await getSyllabuses(this.state.curriculum.selectedYear.id, this.state.curriculum.selectedSubject.id, this.state.curriculum.selectedCurriculumVersion.id)
            : null
          cState.currentLearningSkills = null
          cState.currentContentStandards = null
        } else {
          cState.currentLearningSkills = item && this.state.curriculum.selectedYear && this.state.curriculum.selectedSubject && this.state.curriculum.selectedCurriculumVersion
            ? await getLearningSkills(this.state.curriculum.selectedYear.id, this.state.curriculum.selectedSubject.id, this.state.curriculum.selectedCurriculumVersion.id)
            : null
          cState.currentSyllabuses = null
          cState.currentUnits = null
        }
        break
      case 'selectedLearningSkill':
        cState.currentContentStandards = item ? item.contentStandards : null
        cState.selectedContentStandard = null
        break
      case 'selectedSyllabus':
        cState.currentUnits = item ? item.units : null
        cState.selectedUnit = null
      default:
        break
    }
    return cState
  }

  /**
   *
   * @param {Site} site
   * @param {bool} Whether to hide any future tutorials for the user
   */
  doSiteAdd(site, hideTutorial = false) {
    api.addSite(site.frogstore_site_uuid, hideTutorial)
      .then(newResult => {
        const event = {
          type: 'boost.siteOpened',
          payload: {
            site: site.frogstore_site_uuid
          }
        }
        //set the window __USER immediately- this is normally set when the frame is loaded
        if (hideTutorial)
          window.__USER.preferences.show_tutorial = !hideTutorial

        window.parent.postMessage(event, '*')
        const results = this.state.results.map(result => {
          if (result.item.id == newResult.item.id)
            result = newResult
          return result
        })
        gtagHelper.sendSiteAddEvent(newResult.site, newResult.tags)
        this.setState({
          results,
          selectedSite: null
        })
      }, error => {
        this.setState({
          showGenericErrorModal: true,
          showTutorialModal: false,
          selectedSite: null
        })
      })
  }

  /**
   *
   * @param {string} endpoint
   * @param {Object} queryParams
   */
  doSearch(endpoint, queryParams) {
    this.setState({
      isLoading: !isMobile || typeof queryParams.coorY === 'undefined',
      hasError: false
    }, function () {
      api[endpoint](queryParams)
        .then(data => {
          var newState = {
            results: this.state.results && isMobile && this.state.isMore ? this.state.results.concat(data.items) : data.items,
            result_count: data.meta.total_records,
            isLoading: false,
            unavailableSubject: null
          }
          //check for unavailable subject
          if (data.meta.unavailable_subject) {
            newState = {
              ...newState,
              unavailableSubject: data.meta.unavailable_subject
            }
          }
          this.setState(newState, () => {
            window.scrollTo(0, queryParams.coorY - 30)
          })
        }, error => {
          this.setState({
            isLoading: false,
            hasError: true
          })
        })
    })
  }

  /**
   * Returns a selected year name based on either query params of the window user
   * @param {object} The query parameters
   * @param {object} The window.__USER
   * @return {object} An object with {name: string, fromWindowUser: bool}
   */
  getSelectedYearName(queryParams, windowUser) {
    const obj = { name: '', fromWindowUser: false }
    if (queryParams && queryParams.year) {
      obj.name = queryParams.year
      return obj
    }
    if (windowUser && Array.isArray(windowUser.years) && windowUser.years.length) {
      obj.name = windowUser.years[0]
      obj.fromWindowUser = true
      return obj
    }
    return obj
  }

  /**
   *
   * @param {Site} site
   */
  handleAddingSite(site) {
    try {
      if (!window.__USER.preferences.show_tutorial || this.state.source == 'lessonplanner') {
        this.doSiteAdd(site)
        return
      } else {
        this.setState({
          showTutorialModal: true,
          selectedSite: site
        })
      }
    } catch (e) {
      console.error("Couldn't check the user preferences %O", window.__USER)
      this.doSiteAdd(site)
      return
    }
  }

  handleOrderChange(order) {
    this.setState({
      orderBy: order
    }, this.handleSubmit)
  }

  handleQueryChange(event) {
    this.setState({
      query: event.target.value,
    });
  }

  handleCollectionClear() {
    this.setState({
      selectedCollection: null
    }, this.handleSubmit)
  }

  async handleFilterChange(item, key) {
    const cState = await this.deriveCurriculumStateFromSelection(this.state.curriculum, item, key)
    gtagHelper.sendCurriculumFilterEvent({
      years: cState.selectedYear ? [cState.selectedYear.name] : null,
      subjects: cState.selectedSubject ? [cState.selectedSubject.name] : null,
      curriculumVersions: cState.selectedCurriculumVersion ? [cState.selectedCurriculumVersion.name] : null,
      learningSkills: cState.selectedLearningSkill ? [cState.selectedLearningSkill.name] : null,
      contentStandards: cState.selectedContentStandard ? [cState.selectedContentStandard.name] : null,
      syllabuses: cState.selectedSyllabus ? [cState.selectedSyllabus.name] : null,
      units: cState.selectedUnit ? [cState.selectedUnit.name] : null,
    })
    this.setState({
      ...this.state,
      pagination: {
        ...this.state.pagination,
        offset: 0,
      },
      isMore: false,
      curriculum: cState
    }, this.handleSubmit)
  }

  async handleFilterClear(key) {
    const cState = await this.deriveCurriculumStateFromSelection(this.state.curriculum, null, key)
    this.setState({
      ...this.state,
      pagination: {
        ...this.state.pagination,
        offset: 0,
      },
      isMore: false,
      curriculum: cState
    }, this.handleSubmit)
  }

  handleKeywordClear() {
    this.setState({
      selectedKeywordId: null
    }, this.handleSubmit)
  }

  handleSearchButton(e) {
    e.preventDefault()
    this.setState({
      ...this.state,
      pagination: {
        ...this.state.pagination,
        offset: 0,
      }
    }, this.handleSubmit)

  }

  handleSearchChange(e) {
    this.setState({
      ...this.state,
      isMore: false,
      query: e.target.value
    }, () => {
      if (isMobile) {
        this.handleSubmit(e)
      }
    })
  }

  handleSearchClear(e) {
    this.setState({
      ...this.state,
      isMore: false,
      query: ''
    }, this.handleSubmit)
  }

  handleSubmit(e = null, offset = 0) {
    if (e)
      e.preventDefault()

    const query = this.state.query;
    var params = {
      //init with existing query string
      ...QueryString.parse(this.props.location.search),
      offset,
      q: query
    }
    const filters = {
      orderBy: this.state.orderBy || null,
      year: this.state.curriculum.selectedYear ? this.state.curriculum.selectedYear.name : null,
      subject: this.state.curriculum.selectedSubject ? this.state.curriculum.selectedSubject.name : null,
      curriculumVersion: this.state.curriculum.selectedCurriculumVersion ? this.state.curriculum.selectedCurriculumVersion.name : null,
      curriculumView: this.state.curriculum.selectedCurriculumView ? this.state.curriculum.selectedCurriculumView.name : null,
      learningSkill: this.state.curriculum.selectedLearningSkill ? this.state.curriculum.selectedLearningSkill.uuid : null,
      contentStandard: this.state.curriculum.selectedContentStandard ? this.state.curriculum.selectedContentStandard.uuid : null,
      collection: this.state.selectedCollection ? this.state.selectedCollection.id : null,
      keyword: this.state.selectedKeywordId ? this.state.selectedKeywordId : null,
      syllabus: this.state.curriculum.selectedSyllabus ? this.state.curriculum.selectedSyllabus.uuid : null,
      unit: this.state.curriculum.selectedUnit ? this.state.curriculum.selectedUnit.uuid : null,
    }
    for (var property in filters) {
      if (filters[property] != null) {
        params[property] = filters[property]
      } else {
        if (params[property] != null && params[property] != 'undefined') {
          delete params[property]
        }
      }
    }

    const paramString = QueryString.stringify(params, { arrayFormat: 'bracket' })
    this.props.history.push(`${this.props.match.url}?${paramString}`)
  }

  getCurrentPage() {
    return this.state.pagination.offset == 0
      ? 1
      : Math.floor(this.state.pagination.offset / this.state.pagination.limit) + 1
  }
  /**
   *
   * @param {Integer} pageNum Pages start at 1, not 0
   */
  gotoPage(pageNum) {
    const pagination = this.state.pagination
    const numPages = Math.ceil(this.state.result_count / pagination.limit)
    var offset;

    switch (pageNum) {
      case 0:
      case 1:
        offset = 0
        break
      //last
      case -1:
        offset = (numPages - 1) * pagination.limit
        break
      default:
        offset = Math.floor((pageNum - 1) * pagination.limit)
        break
    }
    this.setState({
      ...this.state,
      currScrollY: this.state.currScrollY - 40,
      pagination: {
        ...pagination,
        offset,
      }
    }, () => {
      if (!isMobile) {
        this.handleSubmit(null, offset)
      } else {
        var coorY = window.scrollY
        const queryParams = QueryString.parse(this.props.location.search)
        setTimeout(() => {
          this.doSearch('siteSearch', { ...queryParams, offset, coorY })
        }, 500);
      }
    })
  }

  nextPage() {
    this.gotoPage(this.getCurrentPage() + 1)
  }

  prevPage() {
    const prev = (this.state.pagination.offset < this.state.pagination.limit)
      ? 1
      : this.getCurrentPage() - 1
    this.gotoPage(prev)
  }

  toggleFilter = () => {
    window.scrollTo(0, 0)
    this.setState({
      ...this.state,
      isFilterShow: false,
      isMobileFilter: !this.state.isMobileFilter
    })
  }

  loadMoreRecords = () => {
    this.gotoPage(this.getCurrentPage() + 1)
  }

  render() {
    const notFoundComponent = (this.state.unavailableSubject)
      ? <div className="vcentered-parent" style={{ height: '100px' }}>
        <div className="vcentered-child container" style={{ textAlign: 'center' }}>
          <img src={this.state.unavailableSubject.image_banner} width="250" height="250" style={{ marginBottom: "-50px" }} />
          <h3 className="frog-font">Coming Soon!</h3>
          <p>
            Get ready to Level Up {this.state.unavailableSubject.subject_name_en} with Boost sites in {this.state.unavailableSubject.availability_date}!
          </p>
        </div>
      </div>
      : <div className="vcentered-parent" style={{ height: '100px' }}>
        <div className="vcentered-child container">
          <p style={{ textAlign: 'center' }}>
            No Boost Site yet? Try using the filters above to find a more relevant Boost Site.
          </p>
        </div>
      </div>
    return (
      <div>
        {isMobile && <BoostSiteFilterMobile
          {...this.state}
          toggleFilter={this.toggleFilter}
          handleSearchButton={this.handleSearchButton}
          handleSearchChange={this.handleSearchChange}
          handleSearchClear={this.handleSearchClear}
          handleFilterChange={this.handleFilterChange}
          handleFilterClear={this.handleFilterClear}
          handleCollectionClear={this.handleCollectionClear}
          FrogPlayPopoverOnClose={() => {
            this.setState({
              showFrogPlayPopover: false
            })
          }}
          YearPopoverOnClose={() => {
            this.setState({
              showYearPopover: false
            })
          }}
          handleOrderChange={this.handleOrderChange}
          isFilterShow={this.state.isFilterShow} />}
        {!isMobile && <BoostSiteFilterWeb
          {...this.state}
          handleKeywordClear={this.handleKeywordClear}
          handleSearchButton={this.handleSearchButton}
          handleSearchChange={this.handleSearchChange}
          handleSearchClear={this.handleSearchClear}
          handleFilterChange={this.handleFilterChange}
          handleFilterClear={this.handleFilterClear}
          handleCollectionClear={this.handleCollectionClear}
          FrogPlayPopoverOnClose={() => {
            this.setState({
              showFrogPlayPopover: false
            })
          }}
          YearPopoverOnClose={() => {
            this.setState({
              showYearPopover: false
            })
          }}
          handleOrderChange={this.handleOrderChange} />}
        <CollectionBanners />
        {this.state.selectedKeywordId &&
          <Jumbotron>
            <h3 className="frog-font">FrogMaker Collections!</h3>
            <p>
              These are templates/Sites for the content standards you have booked in the FrogMaker!
            </p>
            <p>
              Click on Add button to copy them, customize the Sites and submit them to the MOE Repository.
            </p>
          </Jumbotron>
        }
        <div className="container container-fluid">
          {
            !isMobile &&
            <div>
              <div className="pull-left" style={{ marginTop: 20 }}>
                <DropdownButton
                  style={{ width: '100%' }}
                  id={'orderer'}
                  title={`Sort by ${this.state.orderBy}`}
                  bsStyle="default"
                >
                  {this.state.orderChoices.map(choice => (
                    <MenuItem
                      onSelect={this.handleOrderChange}
                      active={choice == this.state.orderBy}
                      key={choice}
                      eventKey={choice}
                    >{choice}
                    </MenuItem>
                  ))}
                </DropdownButton>
              </div>
            </div>
          }
          {
            //show pagination if there has been any search done before.
            !isMobile && Array.isArray(this.state.results) && this.state.results.length > 0 &&
            <div>
              <div className="pull-right" style={{ height: '80px' }}>
                <Pagination
                  count={this.state.result_count}
                  onPrevPage={this.prevPage}
                  onNextPage={this.nextPage}
                  onFirstPage={(e) => this.gotoPage(1)}
                  onLastPage={(e) => this.gotoPage(-1)}
                  pagination={this.state.pagination}
                />
              </div>
              <div className="clearfix"></div>
            </div>
          }
          {isMobile && <div style={{ marginTop: 20 }}></div>}
          {this.state.isLoading &&
            <SearchProgress size="40" margin="100" />
          }
          {!this.state.isLoading && this.state.hasError &&
            <div style={{ marginTop: '100px' }}>
              <GenericError />
            </div>
          }
          {!this.state.isLoading && Array.isArray(this.state.results) && this.state.results.length > 0 &&
            <Row>
              {this.state.results.map(result => {
                const mainThumbnail = result.smallThumbnails.length > 1
                  ? result.smallThumbnails[1]
                  //if only one thumbnail, take that as main thumbnail
                  : result.smallThumbnails.length == 1
                    ? result.smallThumbnails[0]
                    : null
                return (
                  <Col md={3} sm={4} xs={12}
                    key={result.site.frogstore_site_uuid}
                  >
                    {!isMobileOnly &&
                      <Site
                        onAdd={(e) => this.handleAddingSite(result.site)}
                        item={result.item}
                        site={result.site}
                        tags={result.tags}
                        mainThumbnail={mainThumbnail}
                        pageThumbnails={result.mediumThumbnails}
                        source={this.state.source}
                      />
                    }
                    {isMobileOnly &&
                      <SiteMobile
                        onAdd={(e) => this.handleAddingSite(result.site)}
                        item={result.item}
                        site={result.site}
                        tags={result.tags}
                        mainThumbnail={mainThumbnail}
                        pageThumbnails={result.mediumThumbnails}
                        source={this.state.source}
                      />
                    }
                  </Col>
                )
              })}
            </Row>
          }
          {!this.state.isLoading && Array.isArray(this.state.results) && this.state.results.length == 0 &&
            notFoundComponent
          }
          {isMobile && this.state.currScrollY > 200 && <div className="button-back-to-top" onClick={() => window.scrollTo(0, 0)}>
            <FontAwesomeIcon icon={faArrowUp} />
            <div>Top</div>
          </div>}
        </div>
        {!isMobileOnly &&
          <SiteTutorial
            onClose={(hideTutorial) => this.doSiteAdd(
              this.state.selectedSite,
              hideTutorial
            )}
            show={this.state.showTutorialModal}
            site={this.state.selectedSite}
          />
        }
        {isMobileOnly &&
          <SiteTutorialMobile
            onClose={(hideTutorial) => this.doSiteAdd(
              this.state.selectedSite,
              hideTutorial
            )}
            show={this.state.showTutorialModal}
            site={this.state.selectedSite}
          />
        }
        <GenericErrorModal
          show={this.state.showGenericErrorModal}
          onClose={(e) => { this.setState({ showGenericErrorModal: false }) }}
        />
      </div>
    )
  }
}
